import Header from "../../components/Header";
import Container from "../../components/Container";
import Form from "../../components/Form";
import Footer from "../../components/Footer";

function VideoCadastre(){
    return(
        <>
            <Header/>
                <Container>
                    <Form/>
                </Container>
            <Footer/>
        </>
    );
}

export default VideoCadastre;